module.exports = __webpack_public_path__ + "static/media/fa71df11-7b19-4baf-8ff7-3537dea718f0.d0557337.woff";